import React from 'react';
import './styles/ProfileCard.css';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';



const ProfileCard = ({ teacher }) => {
  const navigate = useNavigate();

  const handleViewClasses = () => {
    navigate('/class', { state: { teacher: teacher } });
  };

  const image = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${teacher.collectionId}/${teacher.id}/${teacher.avatar}`;

  return (
    <>
      <div className="m-4">
        <div className="teacher-profile-card">
          <div className="profile-image-container" style={{ 
            width: '150px', 
            height: '150px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            overflow: 'hidden'
          }}>
            <img 
              alt=''
              src={image} 
              className="profile-image"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>

          <div className="profile-content">
            <h3 className="teacher-name">{teacher.name}</h3>
            <p className="teacher-description">
              {teacher.description}
            </p>

            <button 
              className="profile-link-button"  
              onClick={handleViewClasses}>
              View Classes
              <ArrowForwardIos className="link-arrow" />
            </button>
          </div>
        </div>
      </div> 
    </>
  );
};

export default ProfileCard;